import { CustomerPortalProvider, CustomerUsageData, SubscriptionsOverview } from "@stigg/react-sdk";
import classes from "../../utils/classes";
import useModal from "../Modal/hooks/useModal";
import style from "./Billing.module.scss";
import "./overrides.css";
import Modal from "../Modal";
import { PiEnvelopeSimple } from "react-icons/pi";

export default function Billing() {
  const contactModal = useModal();
  // const sessionContext = useContext(AuthContext);
  // const { accessTokenPayload, sessionExists } = sessionContext;

  // if (!checkPermissionAllowed(sessionExists, accessTokenPayload, "users_manage")) {
  //   navigate("/");
  // }

  return (
    <div className={style.wrapper}>
      <div className="container">
        <div className={style.billingWrapper}>
          <div className={style.header}>
            <div>
              <h3>Billing</h3>
              <small>View usage and manage your subscription</small>
            </div>
          </div>
          <CustomerPortalProvider
            theme={{
              backgroundColor: "var(--color-background-modal-shade)",
            }}>
            <div className={classes([style.section, style.subscriptionOverviewWrapper])}>
              <SubscriptionsOverview
                onManageSubscription={() => {
                  contactModal.setOpen(true);
                }}
                cancelScheduledUpdatesButtonTitle="Cancel Scheduled Updates"></SubscriptionsOverview>
            </div>
            <div className={style.section}>
              <CustomerUsageData />
            </div>
          </CustomerPortalProvider>
          {contactModal.openDelayed && (
            <Modal {...contactModal} useBox={true} useCloseButton>
              <div className={style.contactModal}>
                <div className={style.contactCard}>
                  <h2>Contact us</h2>
                  <p>Please contact us to update or cancel your subscription.</p>
                  <div className={style.contactInfo}>
                    {/*<a*/}
                    {/*  href="javascript:void(0)"*/}
                    {/*  className={style.contactItem}*/}
                    {/*  onClick={() => {*/}
                    {/*    contactModal.setOpen(false);*/}
                    {/*    if ("$chatwoot" in window) {*/}
                    {/*      const chatwoot = window["$chatwoot"] as any;*/}
                    {/*      chatwoot.toggle("open");*/}
                    {/*    }*/}
                    {/*  }}>*/}
                    {/*  <PiChat size={18} className={style.icon} />*/}
                    {/*  <span>Chat with us</span>*/}
                    {/*</a>*/}

                    <a className={style.contactItem} href="mailto:hey@tableflow.com" rel="noreferrer noopener">
                      <PiEnvelopeSimple size={18} className={style.icon} />
                      <span>hey@tableflow.com</span>
                    </a>
                  </div>
                </div>
              </div>
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
}
